import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DateFormatPipe } from 'src/app/core/pipes/date-format/date-format.pipe';
import { DistancePipe } from './distance/distance.pipe';
import { CountryWithPostalCodePipe } from './countryWithPostalCodePipe/countryWithPostalCodePipe.pipe';
import { FilterArrayByPropertyPipe } from './filter-array/filter-array-by-property.pipe';

@NgModule({
  declarations: [DistancePipe, CountryWithPostalCodePipe, DateFormatPipe, FilterArrayByPropertyPipe],
  imports: [CommonModule],
  exports: [DistancePipe, CountryWithPostalCodePipe, DateFormatPipe, FilterArrayByPropertyPipe],
  providers: [CountryWithPostalCodePipe]
})
export class PipeModule {}
